export const generateGradientStyle = (colors: string[], degrees: string) => ({
    background: `linear-gradient(${degrees}deg,
      ${colors[0]} 0%,
      ${colors[1]} 15%,
      ${colors[2]} 30%,
      ${colors[0]} 45%,
      ${colors[1]} 60%,
      ${colors[2]} 75%,
      ${colors[0]} 90%,
      ${colors[1]} 100%)`,
    backgroundSize: '300% 300%',
});
